import { type ComponentType } from "react";
import {
  FaMobileAlt as _FaMobileAlt,
  FaDesktop as _FaDesktop,
  FaCheck as _FaCheck,
  FaTimes as _FaTimes,
  FaExclamationTriangle as _FaExclamationTriangle,
  FaDownload as _FaDownload,
  FaPaperPlane as _FaPaperPlane,
  FaClock as _FaClock,
  FaArrowLeft as _FaArrowLeft,
  FaArrowRight as _FaArrowRight,
  FaChevronUp as _FaChevronUp,
  FaChevronDown as _FaChevronDown,
  FaChevronLeft as _FaChevronLeft,
  FaChevronRight as _FaChevronRight,
  FaTrophy as _FaTrophy,
  FaGraduationCap as _FaGraduationCap,
  FaClipboardList as _FaClipboardList,
  FaImage as _FaImage,
  FaUsers as _FaUsers,
  FaLockOpen as _FaLockOpen,
  FaLock as _FaLock,
  FaTrash as _FaTrash,
  FaFileAlt as _FaFileAlt,
  FaStar as _FaStar,
  FaBook as _FaBook,
  FaChartBar as _FaChartBar,
  FaChartLine as _FaChartLine,
  FaUserCircle as _FaUserCircle,
  FaSearch as _FaSearch,
  FaBullhorn as _FaBullhorn,
  FaEnvelope as _FaEnvelope,
  FaQuestionCircle as _FaQuestionCircle,
  FaPlay as _FaPlay,
  FaPlayCircle as _FaPlayCircle,
  FaCertificate as _FaCertificate,
  FaTachometerAlt as _FaTachometerAlt,
  FaVideo as _FaVideo,
  FaStickyNote as _FaStickyNote,
  FaCommentDots as _FaCommentDots,
  FaSignOutAlt as _FaSignOutAlt,
  FaBookOpen as _FaBookOpen,
  FaPencilAlt as _FaPencilAlt,
  FaBars as _FaBars,
  FaUserCog as _FaUserCog,
  FaEye as _FaEye,
  FaEyeSlash as _FaEyeSlash,
  FaCheckCircle as _FaCheckCircle,
  FaListUl as _FaListUl,
  FaThLarge as _FaThLarge,
  FaHistory as _FaHistory,
  FaEdit as _FaEdit,
  FaUserShield as _FaUserShield,
  FaPlus as _FaPlus,
  FaHome as _FaHome,
  FaBell as _FaBell,
  FaInfoCircle as _FaInfoCircle,
  FaEllipsisV as _FaEllipsisV,
  FaSyncAlt as _FaSyncAlt,
  FaWifi as _FaWifi,
  FaExclamationCircle as _FaExclamationCircle,
  FaWhatsapp as _FaWhatsapp,
} from "react-icons/fa";

export const FaMobileAlt        = _FaMobileAlt        as ComponentType<any>;
export const FaDesktop          = _FaDesktop          as ComponentType<any>;
export const FaCheck            = _FaCheck            as ComponentType<any>;
export const FaTimes            = _FaTimes            as ComponentType<any>;
export const FaExclamationTriangle = _FaExclamationTriangle as ComponentType<any>;
export const FaDownload         = _FaDownload         as ComponentType<any>;
export const FaPaperPlane       = _FaPaperPlane       as ComponentType<any>;
export const FaClock            = _FaClock            as ComponentType<any>;
export const FaArrowLeft        = _FaArrowLeft        as ComponentType<any>;
export const FaArrowRight       = _FaArrowRight       as ComponentType<any>;
export const FaChevronUp        = _FaChevronUp        as ComponentType<any>;
export const FaChevronDown      = _FaChevronDown      as ComponentType<any>;
export const FaChevronLeft      = _FaChevronLeft      as ComponentType<any>;
export const FaChevronRight     = _FaChevronRight     as ComponentType<any>;
export const FaTrophy           = _FaTrophy           as ComponentType<any>;
export const FaGraduationCap    = _FaGraduationCap    as ComponentType<any>;
export const FaClipboardList    = _FaClipboardList    as ComponentType<any>;
export const FaImage            = _FaImage            as ComponentType<any>;
export const FaUsers            = _FaUsers            as ComponentType<any>;
export const FaLockOpen         = _FaLockOpen         as ComponentType<any>;
export const FaLock             = _FaLock             as ComponentType<any>;
export const FaTrash            = _FaTrash            as ComponentType<any>;
export const FaFileAlt          = _FaFileAlt          as ComponentType<any>;
export const FaStar             = _FaStar             as ComponentType<any>;
export const FaBook             = _FaBook             as ComponentType<any>;
export const FaChartBar         = _FaChartBar         as ComponentType<any>;
export const FaChartLine        = _FaChartLine        as ComponentType<any>;
export const FaUserCircle       = _FaUserCircle       as ComponentType<any>;
export const FaSearch           = _FaSearch           as ComponentType<any>;
export const FaBullhorn         = _FaBullhorn         as ComponentType<any>;
export const FaEnvelope         = _FaEnvelope         as ComponentType<any>;
export const FaQuestionCircle   = _FaQuestionCircle   as ComponentType<any>;
export const FaPlay             = _FaPlay             as ComponentType<any>;
export const FaPlayCircle       = _FaPlayCircle       as ComponentType<any>;
export const FaCertificate      = _FaCertificate      as ComponentType<any>;
export const FaTachometerAlt    = _FaTachometerAlt    as ComponentType<any>;
export const FaVideo            = _FaVideo            as ComponentType<any>;
export const FaStickyNote       = _FaStickyNote       as ComponentType<any>;
export const FaCommentDots      = _FaCommentDots      as ComponentType<any>;
export const FaSignOutAlt       = _FaSignOutAlt       as ComponentType<any>;
export const FaBookOpen         = _FaBookOpen         as ComponentType<any>;
export const FaPencilAlt        = _FaPencilAlt        as ComponentType<any>;
export const FaBars             = _FaBars             as ComponentType<any>;
export const FaUserCog          = _FaUserCog          as ComponentType<any>;
export const FaEye              = _FaEye              as ComponentType<any>;
export const FaEyeSlash         = _FaEyeSlash         as ComponentType<any>;
export const FaCheckCircle      = _FaCheckCircle      as ComponentType<any>;
export const FaListUl           = _FaListUl           as ComponentType<any>;
export const FaThLarge          = _FaThLarge          as ComponentType<any>;
export const FaHistory          = _FaHistory          as ComponentType<any>;
export const FaEdit             = _FaEdit             as ComponentType<any>;
export const FaUserShield       = _FaUserShield       as ComponentType<any>;
export const FaPlus             = _FaPlus             as ComponentType<any>;
export const FaHome             = _FaHome             as ComponentType<any>;
export const FaBell             = _FaBell             as ComponentType<any>;
export const FaInfoCircle       = _FaInfoCircle       as ComponentType<any>;
export const FaEllipsisV        = _FaEllipsisV        as ComponentType<any>;
export const FaSyncAlt          = _FaSyncAlt          as ComponentType<any>;
export const FaWifi             = _FaWifi             as ComponentType<any>;
export const FaExclamationCircle = _FaExclamationCircle as ComponentType<any>;
export const FaWhatsapp         = _FaWhatsapp         as ComponentType<any>;
